import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import axios from "axios";
import "./index.scss";
import { UploadFile } from "../../../assets/icons/UploadFile";
import img from "../../../assets/images/sphere.png";
import { showSuccessToaster } from "../../toaster/success";
import { showErrorToaster } from "../../toaster/error";
import { useTranslation } from "react-i18next";

const CandidatureSection = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    file: null,
    acceptTerms: false,
  });

  const [loading, setLoading] = useState(false);

  // ✅ Gérer les changements de champs
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]:
        type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
  };

  // ✅ Soumettre le formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.acceptTerms) {
      alert(t("apply.acceptTermsAlert"));
      return;
    }

    try {
      setLoading(true);

      const data = new FormData();
      data.append("fullname", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("cv", formData.file);

      const response = await axios.post(
        "https://api.new-msit-conseil.msit-demo.fr/candidatures",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("✅ Candidature envoyée :", response.data);
      showSuccessToaster(t("apply.successMessage"));

      setFormData({
        name: "",
        email: "",
        phone: "",
        file: null,
        acceptTerms: false,
      });
    } catch (error) {
      console.error("❌ Erreur lors de l’envoi :", error);
      showErrorToaster(t("apply.errorMessage"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="candidature-section">
      <Container>
        <Row className="align-items-center justify-content-center">
          {/* Formulaire */}
          <Col md={6} className="form-col">
            <h2 className="title">
              {t("apply.title")} <br />
              {t("apply.subtitle")}
            </h2>

            <Form onSubmit={handleSubmit} className="mt-4">
              <Form.Group className="mb-4">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder={t("apply.fullName")}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder={t("apply.email")}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Control
                  type="text"
                  name="phone"
                  placeholder={t("apply.phone")}
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              {/* Fichier */}
              <Form.Group controlId="formFile" className="mb-3 file-upload">
                <Form.Label htmlFor="file-upload" className="file-label">
                  <UploadFile />
                </Form.Label>
                <Form.Control
                  id="file-upload"
                  type="file"
                  name="file"
                  onChange={handleChange}
                  accept=".pdf,.doc,.docx"
                  className="file-input"
                  required
                />
                {formData.file && (
                  <small className="file-name text-light mt-1 d-block">
                    📎 {formData.file.name}
                  </small>
                )}
              </Form.Group>

              {/* Termes */}
              <Form.Group className="mb-3 d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  name="acceptTerms"
                  checked={formData.acceptTerms}
                  onChange={handleChange}
                  className="me-2"
                  required
                />
                <Form.Label className="terms mb-0">
                  {t("apply.terms")}
                </Form.Label>
              </Form.Group>

              {/* Bouton */}
              <Button
                type="submit"
                className="submit-btn w-100 mb-5 mb-md-0"
                disabled={loading}>
                {loading ? t("apply.loading") : t("apply.submit")}
              </Button>
            </Form>
          </Col>

          {/* Image */}
          <Col md={6} className="image-col text-center d-none d-md-block">
            <img src={img} alt="visuel" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CandidatureSection;
